import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ProductProps } from "@/interface";

const initialState = {
	activeProduct: {},
};

const productSlice = createSlice({
	name: "products",
	initialState,
	reducers: {
		updateActiveProduct: (state, action: PayloadAction<ProductProps>) => {
			return { 
                ...state,
				activeProduct: action.payload
			};
		},
	

	},
});

export default productSlice.reducer;
export const { updateActiveProduct } = productSlice.actions;
